const tableTitleTableMaintenances = {
  title: 'Manutenções Geradas',
  placeholder: 'Pesquisar',
  rowsPerPage: 'Linhas por Página',
};

export default tableTitleTableMaintenances;
